import Nr from "@/utils/NetworldRequest";

const activityRequest = new Nr({
  baseURL: process.env.VUE_APP_OPENDATA_AFANTIACTIVITY_API,
}).getAxios();

const bffRequest = new Nr({
  baseURL: process.env.VUE_APP_OPENDATA_BFF_API,
}).getAxios();

export default {
  // 获取报表列表
  getReportList(params) {
    return activityRequest.get("/acms/report/manage/pageList", { params });
  },

  // 获取底下用户列表
  getUserList() {
    return activityRequest.get("/acms/report/manage/jjtUserList");
  },

  // 获取角色列表（公开范围-用户角色）
  getRoleList(params) {
    return activityRequest.get("/acms/report/manage/jjtRoleList", { params });
  },

  // 判断当前登录用户是否为总部用户（data: true 总部 / false 大区）
  isHeadquartersUser() {
    return bffRequest.get("/user/listUsersByRoleId");
  },

  // 查询当前登录用户所属大区（接口返回下划线字段 region_id / role_id）
  getRegionRoleList() {
    return bffRequest.get("/user/getRegionRoleList");
  },

  // 获取模板列表
  getTemplateList() {
    return activityRequest.get("/acms/report/manage/template/list");
  },

  // 新增/编辑报表
  editReport(data) {
    return activityRequest.post("/acms/report/manage/update", data);
  },

  // 删除报表
  deleteReport(params) {
    return activityRequest.get("/acms/report/manage/delete", { params });
  },

  // 获取报表详情
  getReportDetail(params) {
    return activityRequest.get("/acms/report/manage/detail", { params });
  },

  // 获取报表可见范围列表
  getReportScopeUserList(params) {
    return activityRequest.get("/acms/report/manage/reportScopeList", {
      params,
    });
  },

  // 判断模板是否已使用
  reportTemplateExists(params) {
    return activityRequest.get("/acms/report/manage/reportTemplateExists", {
      params,
    });
  },
};
